import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["country", "state", "postalCode"]

  connect() {
    this.updateStateOptions()
  }

  countryChanged() {
    this.stateTarget.innerHTML = '<option value="">Select state/province</option>'
    this.updateStateOptions()
  }

  async updateStateOptions() {
    const country = this.countryTarget.value
    if (!country) return

    try {
      const response = await fetch(`/api/v1/addresses/states?country=${encodeURIComponent(country)}`)
      if (!response.ok) throw new Error('Network response was not ok')
      
      const states = await response.json()

      states.forEach(([name, code]) => {
        const option = document.createElement('option')
        option.value = code
        option.textContent = name
        this.stateTarget.appendChild(option)
      })
      this.stateTarget.disabled = false

      if(this.stateTarget.options.length === 2) {
        this.stateTarget.value = this.stateTarget.options[1].value
      }

      if(states.length === 0) {
        this.stateTarget.innerHTML = '<option value="">No states available</option>'
        this.stateTarget.disabled = true
      }

    } catch (error) {
      console.error('Error fetching states:', error)
    }
  }
} 